// extracted by mini-css-extract-plugin
module.exports = {"root":"CloseButton-root-2ENx4","icon":"CloseButton-icon-3duN6"};